import type {FilenameSchemaEntry} from "#material-outputs-filenames/types"
import {DataObjectAssignmentType} from "@cm/utils/data-object-assignment"

export const organizationName = "ldi interiors" as const

export const schemas: FilenameSchemaEntry[] = [
    // tileable renders
    {
        type: DataObjectAssignmentType.MaterialTileableRender,
        schema: "Tileable image - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.$IMAGE_FORMAT$",
        imageFormat: "exr",
        imageResolution: "original",
    },

    {
        type: DataObjectAssignmentType.MaterialTileableRender,
        schema: "Tileable image - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.$IMAGE_FORMAT$",
        imageFormat: "tif",
        imageResolution: "original",
    },

    {
        type: DataObjectAssignmentType.MaterialTileableRender,
        schema: "Tileable image - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.$IMAGE_FORMAT$",
        imageFormat: "jpg",
        imageResolution: "original",
    },

    {
        type: DataObjectAssignmentType.MaterialTileableRender,
        schema: "Tileable image - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-$IMAGE_FORMAT$-1000.$IMAGE_FORMAT$",
        imageFormat: "jpg",
        imageResolution: "px1000",
    },

    {
        type: DataObjectAssignmentType.MaterialTileableRender,
        schema: "Tileable image - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-$IMAGE_FORMAT$-2000.$IMAGE_FORMAT$",
        imageFormat: "jpg",
        imageResolution: "px2000",
    },

    {
        type: DataObjectAssignmentType.MaterialTileableRender,
        schema: "Tileable image - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-$IMAGE_FORMAT$-500.$IMAGE_FORMAT$",
        imageFormat: "jpg",
        imageResolution: "px500",
    },

    // thumbnails
    // 7x7 inches
    {
        type: DataObjectAssignmentType.MaterialThumbnail_7x7Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.exr",
        imageFormat: "exr",
        imageResolution: "original",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_7x7Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.tiff",
        imageFormat: "tif",
        imageResolution: "original",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_7x7Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.jpg",
        imageFormat: "jpg",
        imageResolution: "original",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_7x7Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-jpg-1000.jpg",
        imageFormat: "jpg",
        imageResolution: "px1000",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_7x7Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-jpg-2000.jpg",
        imageFormat: "jpg",
        imageResolution: "px2000",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_7x7Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-jpg-500.jpg",
        imageFormat: "jpg",
        imageResolution: "px500",
    },

    // 9x9 inches
    {
        type: DataObjectAssignmentType.MaterialThumbnail_9x9Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.exr",
        imageFormat: "exr",
        imageResolution: "original",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_9x9Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.tiff",
        imageFormat: "tif",
        imageResolution: "original",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_9x9Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.jpg",
        imageFormat: "jpg",
        imageResolution: "original",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_9x9Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-jpg-1000.jpg",
        imageFormat: "jpg",
        imageResolution: "px1000",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_9x9Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-jpg-2000.jpg",
        imageFormat: "jpg",
        imageResolution: "px2000",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_9x9Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-jpg-500.jpg",
        imageFormat: "jpg",
        imageResolution: "px500",
    },

    // 10x10 cm
    {
        type: DataObjectAssignmentType.MaterialThumbnail_10x10,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.exr",
        imageFormat: "exr",
        imageResolution: "original",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_10x10,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.tiff",
        imageFormat: "tif",
        imageResolution: "original",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_10x10,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.jpg",
        imageFormat: "jpg",
        imageResolution: "original",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_10x10,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-jpg-1000.jpg",
        imageFormat: "jpg",
        imageResolution: "px1000",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_10x10,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-jpg-2000.jpg",
        imageFormat: "jpg",
        imageResolution: "px2000",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_10x10,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-jpg-500.jpg",
        imageFormat: "jpg",
        imageResolution: "px500",
    },

    // 15x15 cm
    {
        type: DataObjectAssignmentType.MaterialThumbnail_15x15,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.exr",
        imageFormat: "exr",
        imageResolution: "original",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_15x15,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.tiff",
        imageFormat: "tif",
        imageResolution: "original",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_15x15,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.jpg",
        imageFormat: "jpg",
        imageResolution: "original",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_15x15,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-jpg-1000.jpg",
        imageFormat: "jpg",
        imageResolution: "px1000",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_15x15,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-jpg-2000.jpg",
        imageFormat: "jpg",
        imageResolution: "px2000",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_15x15,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-jpg-500.jpg",
        imageFormat: "jpg",
        imageResolution: "px500",
    },

    // 16x16 inches
    {
        type: DataObjectAssignmentType.MaterialThumbnail_16x16Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.exr",
        imageFormat: "exr",
        imageResolution: "original",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_16x16Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.tiff",
        imageFormat: "tif",
        imageResolution: "original",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_16x16Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.jpg",
        imageFormat: "jpg",
        imageResolution: "original",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_16x16Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-jpg-1000.jpg",
        imageFormat: "jpg",
        imageResolution: "px1000",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_16x16Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-jpg-2000.jpg",
        imageFormat: "jpg",
        imageResolution: "px2000",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_16x16Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-jpg-500.jpg",
        imageFormat: "jpg",
        imageResolution: "px500",
    },

    // 20x20 cm
    {
        type: DataObjectAssignmentType.MaterialThumbnail_20x20,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.exr",
        imageFormat: "exr",
        imageResolution: "original",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_20x20,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.tiff",
        imageFormat: "tif",
        imageResolution: "original",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_20x20,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.jpg",
        imageFormat: "jpg",
        imageResolution: "original",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_20x20,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-jpg-1000.jpg",
        imageFormat: "jpg",
        imageResolution: "px1000",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_20x20,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-jpg-2000.jpg",
        imageFormat: "jpg",
        imageResolution: "px2000",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_20x20,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-jpg-500.jpg",
        imageFormat: "jpg",
        imageResolution: "px500",
    },

    // 30x30 cm
    {
        type: DataObjectAssignmentType.MaterialThumbnail_30x30,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.exr",
        imageFormat: "exr",
        imageResolution: "original",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_30x30,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.tiff",
        imageFormat: "tif",
        imageResolution: "original",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_30x30,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.jpg",
        imageFormat: "jpg",
        imageResolution: "original",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_30x30,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-jpg-1000.jpg",
        imageFormat: "jpg",
        imageResolution: "px1000",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_30x30,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-jpg-2000.jpg",
        imageFormat: "jpg",
        imageResolution: "px2000",
    },

    {
        type: DataObjectAssignmentType.MaterialThumbnail_30x30,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-jpg-500.jpg",
        imageFormat: "jpg",
        imageResolution: "px500",
    },

    // 8x8 inches
    {
        type: DataObjectAssignmentType.MaterialThumbnail_8x8Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.exr",
        imageFormat: "exr",
        imageResolution: "original",
    },
    {
        type: DataObjectAssignmentType.MaterialThumbnail_8x8Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.tiff",
        imageFormat: "tif",
        imageResolution: "original",
    },
    {
        type: DataObjectAssignmentType.MaterialThumbnail_8x8Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.jpg",
        imageFormat: "jpg",
        imageResolution: "original",
    },
    {
        type: DataObjectAssignmentType.MaterialThumbnail_8x8Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-jpg-1000.jpg",
        imageFormat: "jpg",
        imageResolution: "px1000",
    },
    {
        type: DataObjectAssignmentType.MaterialThumbnail_8x8Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-jpg-2000.jpg",
        imageFormat: "jpg",
        imageResolution: "px2000",
    },
    {
        type: DataObjectAssignmentType.MaterialThumbnail_8x8Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-jpg-500.jpg",
        imageFormat: "jpg",
        imageResolution: "px500",
    },

    // 13_5x13_5 inches
    {
        type: DataObjectAssignmentType.MaterialThumbnail_13_5x13_5Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.exr",
        imageFormat: "exr",
        imageResolution: "original",
    },
    {
        type: DataObjectAssignmentType.MaterialThumbnail_13_5x13_5Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.tiff",
        imageFormat: "tif",
        imageResolution: "original",
    },
    {
        type: DataObjectAssignmentType.MaterialThumbnail_13_5x13_5Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.jpg",
        imageFormat: "jpg",
        imageResolution: "original",
    },
    {
        type: DataObjectAssignmentType.MaterialThumbnail_13_5x13_5Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-jpg-1000.jpg",
        imageFormat: "jpg",
        imageResolution: "px1000",
    },
    {
        type: DataObjectAssignmentType.MaterialThumbnail_13_5x13_5Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-jpg-2000.jpg",
        imageFormat: "jpg",
        imageResolution: "px2000",
    },
    {
        type: DataObjectAssignmentType.MaterialThumbnail_13_5x13_5Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-jpg-500.jpg",
        imageFormat: "jpg",
        imageResolution: "px500",
    },

    // 27x27 inches
    {
        type: DataObjectAssignmentType.MaterialThumbnail_27x27Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.exr",
        imageFormat: "exr",
        imageResolution: "original",
    },
    {
        type: DataObjectAssignmentType.MaterialThumbnail_27x27Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.tiff",
        imageFormat: "tif",
        imageResolution: "original",
    },
    {
        type: DataObjectAssignmentType.MaterialThumbnail_27x27Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.jpg",
        imageFormat: "jpg",
        imageResolution: "original",
    },
    {
        type: DataObjectAssignmentType.MaterialThumbnail_27x27Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-jpg-1000.jpg",
        imageFormat: "jpg",
        imageResolution: "px1000",
    },
    {
        type: DataObjectAssignmentType.MaterialThumbnail_27x27Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-jpg-2000.jpg",
        imageFormat: "jpg",
        imageResolution: "px2000",
    },
    {
        type: DataObjectAssignmentType.MaterialThumbnail_27x27Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-jpg-500.jpg",
        imageFormat: "jpg",
        imageResolution: "px500",
    },

    // 32x32 inches
    {
        type: DataObjectAssignmentType.MaterialThumbnail_32x32Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.exr",
        imageFormat: "exr",
        imageResolution: "original",
    },
    {
        type: DataObjectAssignmentType.MaterialThumbnail_32x32Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.tiff",
        imageFormat: "tif",
        imageResolution: "original",
    },
    {
        type: DataObjectAssignmentType.MaterialThumbnail_32x32Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm.jpg",
        imageFormat: "jpg",
        imageResolution: "original",
    },
    {
        type: DataObjectAssignmentType.MaterialThumbnail_32x32Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-jpg-1000.jpg",
        imageFormat: "jpg",
        imageResolution: "px1000",
    },
    {
        type: DataObjectAssignmentType.MaterialThumbnail_32x32Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-jpg-2000.jpg",
        imageFormat: "jpg",
        imageResolution: "px2000",
    },
    {
        type: DataObjectAssignmentType.MaterialThumbnail_32x32Inches,
        schema: "Thumbnail - $MATERIAL_NAME$ - $MATERIAL_ARTICLE_ID$ - $WIDTH_CM$cm x $HEIGHT_CM$cm-jpg-500.jpg",
        imageFormat: "jpg",
        imageResolution: "px500",
    },
]
